import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from 'govuk-react-jsx';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';

const MobileVerified = () => {
  const history = useHistory();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'landlordReg.MobileVerified.s4',
    'You have verified your mobile number - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const handleBtnClick = () => {
    history.push('/pmcReg/create-password');
  };

  return (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordReg.MobileVerified.s1',
          'You have verified your mobile number'
        )}
      </h1>
      <Button
        className="govuk-button govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy('landlordReg.MobileVerified.s3', 'Continue')}
      </Button>
    </>
  );
};

export default MobileVerified;
